export const RESPONSE_MESSAGE = {
  UPDATE_SUCCESS: 'Inventory updated successfully.',
};
